export default {
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    agree: 'ยินยอม',
    headerRegister: 'ลงทะเบียน',
    lineConsent: JSON.stringify([
        {
            infos: [
                'บริษัท พรีเมี่ยม ซัฟฟิเชี่ยน โซลูชั่นส์ กรุ๊ปส์ จำกัด (“บริษัทฯ”) เล็งเห็นถึงความสำคัญของการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการ ' +
                'เราทราบดีว่าผู้ใช้บริการเป็นห่วงและให้ความสำคัญกับวิธีการที่ข้อมูลของผู้ใช้บริการจะถูกเก็บรวบรวม ใช้ เปิดเผย และ ' +
                'ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราจะนำข้อมูลที่ผู้ใช้บริการแบ่งปันให้กับเรานั้นไปใช้เพื่อการให้บริการเพื่ออำนวย' +
                'ความสะดวกแก่ผู้ใช้บริการเป็นสำคัญ บริษัทฯ ซาบซึ้งในความไว้วางใจของผู้ใช้บริการและเราจะดูแลข้อมูลส่วนบุคคล' +
                'ของผู้ใช้บริการด้วยความระมัดระวังและอย่างสมเหตุสมผล ในการมอบประสบการณ์และการให้บริการอย่างดีที่สุดให้แก่ผู้ใช้บริการ',

                'นโยบายความเป็นส่วนตัวฉบับนี้ (“นโยบายความเป็นส่วนตัว”) มีวัตถุประสงค์เพื่อขอความยินยอม และแจ้งวิธีการแก่ผู้ใช้บริการ ' +
                '(ตามที่จะได้นิยามต่อไป) ที่บริษัทฯ จะเก็บรวบรวม ใช้ และ เปิดเผย “ข้อมูลส่วนบุคคล” (ตามที่จะได้นิยามต่อไป) ' +
                'ในส่วนที่เกี่ยวกับการให้บริการทั้งหมดที่เกี่ยวข้องของบริษัทฯ (ตามที่จะได้นิยามต่อไป) ' +
                'ภายใต้บทบัญญัติของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (และที่แก้ไขเพิ่มเติม) ' +
                'รวมทั้งประกาศที่เกี่ยวข้อง (“กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล”)',

                'ผู้ใช้บริการโปรดอ่านนโยบายความเป็นส่วนตัวฉบับนี้ เพื่อรับทราบและทำความเข้าใจในวัตถุประสงค์ที่บริษัทฯ ' +
                'ได้เก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการ'
            ]
        },
        {
            header: '1. คำจำกัดความ',
            sections: [
                {
                    topics: [
                        '1.1. เว้นแต่ข้อความในนโยบายความเป็นส่วนตัวฉบับนี้ กำหนดไว้เป็นประการอื่น ให้คำและข้อความต่าง ๆ ' +
                        'ดังต่อไปนี้ ในนโยบายความเป็นส่วนตัวฉบับนี้ มีความหมายดังนี้',

                        '“บริษัทฯ” หมายถึง บริษัท พรีเมี่ยม ซัฟฟิเชี่ยน โซลูชั่นส์ กรุ๊ปส์ จำกัด',

                        '“ข้อมูลส่วนบุคคล” หมายถึง ข้อมูลเกี่ยวกับบุคคลซึ่ทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือ ทางอ้อม ' +
                        'แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ',

                        '“บริการ” หมายถึง บริการทั้งหมดที่เกี่ยวข้องของบริษัทฯ ไม่ว่าจะมีการลงทะเบียนเพื่อเปิดบัญชีหรือไม่ก็ตาม ' +
                        'และไม่ว่าจะมีค่าตอบแทนหรือไม่ก็ตาม ซึ่งรวมถึงการให้บริการระบบตรวจสอบการเข้าและออก ภายในองกรค์',

                        '“องกรค์” หมายถึง องกรค์ที่บริษัทฯ ให้บริการ และผู้ใช้ บริการประกอบอาชีพ หรือกระทำกิจกรรมใดๆ ภายในองกรค์ดังกล่าว',

                        '“ผู้ใช้บริการ” หมายถึง บุคคลใด ๆ ที่ใช้บริการจากบริษัทฯ ซึ่งรวมถึง',
                        '(1) บุคลากรในองกรค์',
                        '(2) ผู้ประกอบการภายในองกรค์'
                    ]
                }
            ]
        },
        {
            header: '2. การเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล',
            sections: [
                {
                    topics: [
                        '2.1. ในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล ของผู้ใช้บริการ บริษัทฯ ' +
                        'จะกระทำการ และใช้วิธีการที่ชอบด้วยกฎหมายและเป็นธรรม'
                    ]
                },
                {
                    topics: [
                        '2.2. ในการเก็บรวบรวมข้อมูลส่วนบุคคล บริษัทฯ จะกระทำเพียงเท่าที่จำเป็นภายใต้วัตถุประสงค์ตามข้อ 4.'
                    ]
                },
                {
                    topics: [
                        '2.3. บริษัทฯ จะสามารถเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการ ก็ต่อเมื่อได้รับความยินยอมจากผู้ใช้บริการ ' +
                        'เว้นแต่กรณีที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนดไว้'
                    ]
                }
            ]
        },
        {
            header: '3. ข้อมูลส่วนบุคคลที่บริษัทฯ เก็บรวบรวม ใช้ หรือ เปิดเผย',
            sections: [
                {
                    topics: ['3.1. บริษัทฯ จะดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคล ดังต่อไปนี้ เพื่อนำข้อมูลดังกล่าวไปใช้ หรือเปิดเผย'],
                    details: [
                        '3.1.1. ข้อมูลพื้นฐานของผู้ใช้บริการ เช่น ',

                        '(ก) ชื่อ-สกุล หรือชื่ออื่น ๆ ที่สามารถระบุตัวตนของผู้ใช้บริการได้',

                        '(ข) หมายเลขประจำตัวประชาชน เลขหนังสือเดินทาง หรือ หมายเลขอื่นใดที่สามารถระบุตัวตนของผู้ใช้บริการได้',

                        '(ค) สัญชาติ เชื้อชาติ ศาสนา',

                        '(ง) คำนำหน้า เพศ สถานะการสมรส',

                        '(จ) อายุ วันเดือนปีเกิด ',

                        '(ฉ) ข้อมูลสำหรับการติดต่อผู้ใช้บริการ เช่น ที่อยู่ หมายเลขโทรศัพท์ อีเมล',

                        '(ช) อาชีพ รายได้ ประวัติการศึกษา ประวัติการทำงาน',

                        '(ซ) รูปถ่ายตนเอง รูปถ่ายบัตรประจำตัวประชาชน หรือ บัตรประจำตัวใด ๆ ที่สามารถยืนยันตัวตนของผู้ใช้บริการได้',

                        '(ฌ) ข้อมูลเกี่ยวกับการชำระเงิน เช่น หมายเลขบัตรเครดิต หมายเลขบัตรเดบิต หมายเลขบัญชีธนาคาร',

                        '(ญ) ชื่อผู้ใช้ (Username) และรหัสผ่าน (Password) รหัสยืนยันตัวตน ' +
                        '(PIN: Personal Identification Number) ลายนิ้วมือ ใบหน้า เทคโนโลยีทางชีวภาพ รหัสผ่าน ' +
                        'เพื่อใช้งานอุปกรณ์ของผู้ใช้บริการ รหัส OTP (One Time Password)',

                        '(ฎ) ข้อมูลเกี่ยวกับสิ่งที่ผู้ใช้บริการค้นหา ดู หรือ เยี่ยมชม ในขณะที่ใช้บริการ หรือ ใช้เว็บไซต์ แอพพลิเคชั่น ' +
                        'และสื่อดิจิตอลใด ๆ ของบริษัทฯ (รวมเรียกว่า “แพลตฟอร์ม”) ซึ่งรวมถึงประวัติและเวลาการเข้าเยี่ยมชม ' +
                        'ใช้บริการหรือใช้งานแพลตฟอร์ม ประเภทบราวเซอร์ (Browser) ไอพีแอดเดรส (IP Address) ' +
                        'ข้อมูลตำแหน่งที่ตั้งของผู้ใช้บริการ ข้อมูลอุปกรณ์ของผู้ใช้บริการ (Device Information) ' +
                        '(เช่น รุ่นของอุปกรณ์ ประเภทระบบปฏิบัติการ) ในขณะใช้บริการหรือเยี่ยมชมเว็บไซต์ของบริษัทฯ',

                        '(ฏ) ข้อมูลเกี่ยวกับการใช้บริการ ซึ่งรวมถึงความสนใจและความต้องการของผู้ใช้บริการ เช่น ประวัติการใช้งาน ประวัติการเข้าออกองกรค์'
                    ]
                }
            ]
        },
        {
            header: '4. วัตถุประสงค์ในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล',
            sections: [
                {
                    topics: [
                        '4.1. บริษัทฯ จะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล ภายในขอบวัตถุประสงค์ดังต่อไปนี้'
                    ],
                    details: [
                        '4.1.1. เพื่อการให้บริการที่มีประสิทธิภาพโดยบริษัทฯ แก่ผู้ใช้บริการ ตลอดจนการตรวจสอบและปรับปรุงการให้บริการต่าง ๆ ' +
                        'ของบริษัทฯ และเพื่อการเข้าทำและปฏิบัติตามสัญญาซึ่งผู้ใช้บริการเป็นคู่สัญญากับบริษัทฯ หรือเพื่อดำเนินการตามคำขอของ' +
                        'เจ้าของข้อมูลส่วนบุคคล ซึ่งรวมถึงการให้บริการเพื่อการรักษาความปลอดภัยของผู้ใช้บริการ และป้องกันมิให้เกิดอาชญากรรมต่าง ๆ ' +
                        'กับผู้ใช้บริการ การอำนวยความสะดวกด้านการสื่อสารระหว่างผู้ใช้บริการ บริษัท หรือบุคคลที่สาม ' +
                        'การสนับสนุนและอำนวยความสะดวกในการดำเนินกิจกรรมที่เกี่ยวกับวิชาการของผู้ใช้บริการ เป็นต้น',

                        '4.1.2. เพื่อให้ข้อมูล ประชาสัมพันธ์ และเป็นช่องทางการสื่อสารเกี่ยวกับข่าวสารและบริการต่าง ๆ ให้แก่ผู้ใช้บริการ ' +
                        'การทำการตลาดเกี่ยวกับบริการโดยทั่วไป ผลิตภัณฑ์ และสิทธิประโยชน์การแจ้งเตือน ' +
                        'การแจ้งข่าวสารและข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการซึ่งรวมไปถึงบริการทางโฆษณาจากบริษัทฯ ' +
                        'บริษัทในเครือ และ/หรือพันธมิตรทางธุรกิจแก่ผู้ใช้บริการ',

                        '4.1.3. เพื่อสื่อสารและให้บริการลูกค้าสัมพันธ์แก่ผู้ใช้บริการ อาทิ การให้บริการสนับสนุนผู้ใช้บริการ ' +
                        'การให้ความช่วยเหลือทางเทคนิคและแก้ไขปัญหาทางเทคนิค การตอบข้อซักถาม ข้อร้องเรียนใด ๆ จากผู้ใช้บริการ',

                        '4.1.4. เพื่อการวิเคราะห์ข้อมูล เพื่อให้ผู้ใช้บริการได้รับบริการอย่างมีประสิทธิภาพ เช่น ' +
                        'การจัดทำรายงานผลการเข้างาน เพื่อพัฒนาศักยภาพขององกรค์',

                        '4.1.5. เพื่อประเมินความสนใจหรือพฤติกรรมของผู้ใช้บริการที่มีต่อผลิตภัณฑ์และการบริการ เพื่อดำเนินการวิเคราะห์ข้อมูล ' +
                        '(Data analytics) การทำความสะอาดข้อมูล (Data cleansing) และการวิเคราะห์ข้อมูลตามความสนใจ' +
                        'หรือพฤติกรรมของลูกค้า (Data profiling) เพื่อทำการค้นคว้าวิจัยทางการตลาด ทำแบบสำรวจ ประเมินผล ' +
                        'พฤติกรรม สถิติและการแบ่งประเภท รูปแบบและกระแสความนิยมด้านการบริโภค เพื่อให้เข้าใจและสามารถกำหนดรูปแบบ' +
                        'การให้บริการที่ผู้ใช้บริการพึงพอใจ รวมถึงสามารถเสนอผลิตภัณฑ์ สินค้า และบริการ พร้อมทั้งข้อเสนอพิเศษ กลยุทธ์ ' +
                        'หรือโปรแกรมทางการตลาดที่อาจเกี่ยวเนื่องกับความพึงพอใจและประวัติของผู้ใช้บริการ',

                        '4.1.6. เพื่อประเมิน พัฒนา จัดการและยกระดับ ค้นคว้าวิจัยและพัฒนาการให้บริการ ผลิตภัณฑ์ ' +
                        'ระบบและการดำเนินธุรกิจให้แก่บริษัทฯ บริษัทในเครือ และพันธมิตรทางธุรกิจของบริษัทฯ เพื่อระบุและแก้ไขปัญหาที่เกิดขึ้น ' +
                        'เพื่อจัดทำรายงานภาพรวมของข้อมูลแบบไม่ระบุชื่อ และประเมินประสิทธิภาพในเรื่องผลิตภัณฑ์ สื่อดิจิทัล และแคมเปญทางการตลาด',

                        '4.1.7. เพื่อการตรวจสอบตัวตนของผู้ใช้บริการ เมื่อจำเป็น หรือเมื่อบริษัทฯ ได้รับการร้องขอ หรือคำสั่งจากผู้ใช้บริการ',

                        '4.1.8. เพื่อความมั่นคงปลอดภัย และป้องกันมิให้เกิดการฉ้อโกง อาชญากรรมใด ๆ หรือการกระทำใด ๆ ' +
                        'ที่ไม่ชอบด้วยกฎหมาย รวมถึงการจัดการความเสี่ยงในเชิงพาณิชย์ และการดำเนินการเกี่ยวกับข้อพิพาทต่าง ๆ',

                        '4.1.9. เพื่อวัตถุประสงค์ในการวิเคราะห์และติดตามการใช้บริการ และวัตถุประสงค์ในการตรวจสอบย้อนหลัง ' +
                        'ในกรณีที่เกิดปัญหาการใช้งาน และเพื่อให้แน่ใจว่าแพลตฟอร์มของบริษัทฯ สามารถทำงาน และให้บริการได้อย่างถูกต้อง ' +
                        'ปลอดภัย และสามารถอำนวยความสะดวกให้แก่ผู้ใช้บริการได้อย่างเต็มที่',

                        '4.1.10. เพื่อให้บรรลุวัตถุประสงค์เกี่ยวกับการจัดทำเอกสารประวัติศาสตร์ หรือ หอจดหมายเหตุเพื่อประโยชน์สาธารณะ ' +
                        'หรือที่เกี่ยวกับการศึกษาวิจัย และสถิติ ซึ่งได้จัดให้มีมาตรการปกปองที่เหมาะสม ' +
                        'เพื่อคุ้มครองสิทธิเสรีภาพของผู้ใช้บริการ ทั้งนี้ ตามที่กฎหมายกำหนด(ถ้ามี)',

                        '4.1.11. เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของผู้ใช้บริการ',

                        '4.1.12. เมื่อมีความจำเป็นเพื่อการปฏิบัติหน้าที่ในการดำเนินภารกิจเพื่อประโยชน์อันชอบด้วยกฎหมายของบริษัทฯ ' +
                        'เช่น การตรวจจับ ป้องกัน และตอบโต้ข้อเรียกร้องการทุจริต การละเมิดทรัพย์สินทางปัญญา หรือการไม่ปฏิบัติตามกฎหมาย ' +
                        'เพื่อจัดการและป้องกันความเสียหายแก่ทรัพย์สินและสมบัติของบริษัทฯ เพื่อการปฏิบัติตามข้อกำหนดและเงื่อนไขของบริษัทฯ ' +
                        'เพื่อตรวจจับและป้องกันการประพฤติที่มิชอบซึ่งรวมไปถึงการใช้กล้องวงจรปิด เพื่อติดตามเฝ้าระวังเหตุการณ์ ' +
                        'เพื่อป้องกันและรายงานความผิดทางอาญา และเพื่อปกป้องความมั่นคงและและความเชื่อมั่นทางธุรกิจของบริษัทฯ ' +
                        'หรือการปฏิบัติหน้าที่ในการใช้อำนาจรัฐ ในกรณีที่บริษัทฯ มีอำนาจ',

                        '4.1.13. เพื่อการปรับโครงสร้าง เปลี่ยนแปลง หรือปรับเปลี่ยนธุรกิจของบริษัทฯ ในการนี้ข้อมูลส่วนบุคคลของผู้ใช้บริการ ' +
                        'อาจได้รับการถ่ายโอนไปยังบุคคลที่สามเพื่อประโยชน์ในการตรวจสอบและวิเคราะห์การปรับโครงสร้าง เปลี่ยนแปลง หรือปรับเปลี่ยนธุรกิจของบริษัทฯ'
                    ]
                },
                {
                    topics: [
                        '4.2. เมื่อบริษัทฯ จะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล ที่แตกต่างไปจากวัตถุประสงค์ตามข้อ 4.1 ' +
                        'ของนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ บริษัทฯ จะแจ้งวัตถุประสงค์ใหม่ให้ผู้ใช้บริการทราบ ' +
                        'และดำเนินการ ขอความยินยอมจากผู้ใช้บริการก่อน'
                    ]
                }
            ]
        },
        {
            header: '5. ระยะเวลาในการเก็บรวบรวมข้อมูลส่วนบุคคล',
            sections: [
                {
                    topics: [
                        '5.1. ข้อมูลส่วนบุคคลของผู้ใช้บริการ จะถูกเก็บรวบรวมไว้ตลอดระยะเวลาที่ผู้ใช้บริการมีความสัมพันธ์ ' +
                        '(รวมถึงนิติสัมพันธ์) กับองกรค์ และตลอดระยะ หลังจากวันที่ความสัมพันธ์ ระหว่างผู้ใช้บริการ และองกรค์สิ้นสุดลง ' +
                        'อนึ่ง ความสัมพันธ์ระหว่างผู้ใช้บริการ และองกรค์ เช่น การปฏิบัติงาน ทำธุรกรรม ' +
                        'หรือประกอบอาชีพในองกรค์ของบุคลากร หรือผู้ประกอบการภายในองกรค์'
                    ]
                }
            ]
        },
        {
            header: '6. สิทธิของผู้ใช้บริการ',
            sections: [
                {
                    topics: [
                        'บริษัทฯ ขอเรียนว่าผู้ใช้บริการมีสิทธิในฐานะเจ้าของข้อมูลส่วนบุคคล ดังต่อไปนี้ ทั้งนี้ ' +
                        'ตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด'
                    ]
                },
                {
                    topics: [
                        '6.1. ผู้ใช้บริการมีสิทธิถอนความยินยอมในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้บริการ ในเวลาใด ๆ ก็ได้ ' +
                        'เมื่อผู้ใช้บริการถอนความยินยอมแล้ว การถอนความยินยอมดังกล่าวจะไม่ส่งผลกระทบต่อการเก็บรวบรวม ใช้ ' +
                        'หรือเปิดเผยข้อมูลส่วนบุคคลที่ผู้ใช้บริการได้ให้ความยินยอมไปแล้ว'
                    ]
                },
                {
                    topics: [
                        '6.2. ผู้ใช้บริการมีสิทธิขอเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคลที่เกี่ยวกับผู้ใช้บริการ ซึ่งอยู่ในความรับผิดชอบของบริษัทฯ ' +
                        'หรือขอให้เปิดเผยถึงการได้มาซึ่งข้อมูลส่วนบุคคลที่ผู้ใช้บริการไม่ได้ให้ความยินยอม'
                    ]
                },
                {
                    topics: [
                        '6.3. ผู้ใช้บริการมีสิทธิขอรับข้อมูลส่วนบุคคลที่เกี่ยวกับผู้ใช้บริการจากบริษัทฯ ในกรณีที่บริษัทฯ ได้ทำให้ข้อมูลส่วนบุคคลนั้น ' +
                        'อยู่ในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้ด้วยเครื่องมือ และอุปกรณ์ที่ทำงานได้โดยอัตโนมัติ ' +
                        'และสามารถใช้เปิดเผยข้อมูลส่วนบุคคล ได้ด้วยวิธีการอัตโนมัติ รวมทั้งมีสิทธิดังต่อไปนี้'
                    ],
                    details: [
                        '6.3.1. ขอให้บริษัทฯ ส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังบุคคลอื่น เมื่อสามารถทำได้โดยวิธีการอัตโนมัติ',

                        '6.3.2. ขอรับข้อมูลส่วนบุคคลที่บริษัทฯ ส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังบุคคลอื่นโดยตรง ' +
                        'เว้นแต่โดยสภาพทางเทคนิคไม่สามารถทำได้'
                    ]
                },
                {
                    topics: [
                        '6.4. ผู้ใช้บริการมีสิทธิคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลเกี่ยวกับตนเมื่อใดก็ได้'
                    ]
                },
                {
                    topics: [
                        '6.5. ผู้ใช้บริการมีสิทธิขอให้บริษัทฯ ดำเนินการลบหรือทำลาย หรือทำให้ข้อมูลส่วนบุคคล ' +
                        'เป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้ตามที่กฎหมายกำหนด'
                    ]
                },
                {
                    topics: [
                        '6.6. ผู้ใช้บริการมีสิทธิขอให้ผู้ควบคุมข้อมูลส่วนบุคคลระงับการใช้ข้อมูลส่วนบุคคลได้ตามที่กฎหมายกำหนด'
                    ]
                },
                {
                    topics: [
                        '6.7. ผู้ใช้บริการมีสิทธิขอให้บริษัทฯ ดำเนินการให้ข้อมูลส่วนบุคคลของผู้ใช้บริการถูกต้อง เป็นปัจจุบัน สมบูรณ์ ' +
                        'และไม่ก่อให้เกิดความเข้าใจผิด ในกรณีที่ผู้ใช้บริการร้องขอ แต่บริษัทไม่ดำเนินการดังกล่าว บริษัทฯ ' +
                        'ต้องบันทึกคำร้องขอของผู้ใช้บริการไว้พร้อมด้วยเหตุผล ตามที่กฎหมายกำหนด'
                    ]
                },
                {
                    topics: [
                        '6.8. ผู้ใช้บริการมีสิทธิร้องเรียนในกรณีที่บริษัทฯรวมถึงลูกจ้าง หรือผู้รับจ้างของบริษัทฯ ' +
                        'ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล'
                    ]
                }
            ]
        },
        {
            header: '7. การรักษาความมั่นคงปลอดภัย',
            sections: [
                {
                    topics: [
                        '7.1. บริษัทฯ ตระหนักถึงความสำคัญในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของผู้ใช้บริการ บริษัทฯ ' +
                        'จะใช้ความระมัดระวังในการรักษาข้อมูลส่วนบุคคลของผู้ใช้บริการ มิให้มีการเข้าถึง ทำลาย ใช้ เปลี่ยนแปลง แก้ไข ' +
                        'เปิดเผย หรือการกระทำอื่นใดต่อข้อมูลส่วนบุคคลของผู้ใช้บริการโดยไม่ชอบด้วยกฎหมาย ตลอดระยะเวลาที่ผู้ใช้บริการ ' +
                        'ใช้บริการของบริษัทฯ โดยให้เป็นไปตามที่กำหนดในนโยบาย และแนวปฏิบัติในการรักษาความมั่นคงปลอดภัย ' +
                        'ด้านเทคโนโลยีสารสนเทศของบริษัทฯ'
                    ]
                }
            ]
        },
        {
            header: '8. ข้อตกลงอื่น ๆ',
            sections: [
                {
                    topics: [
                        '8.1. หากผู้ใช้บริการตัดสินใจยกเลิกบัญชีในการใช้บริการต่าง ๆ และ/หรือยุติการใช้บริการใด ๆ ของบริษัทฯ ' +
                        'ข้อมูลทั้งหมด (รวมถึง แต่ไม่จำกัดเฉพาะข้อมูลส่วนบุคคล) ที่เกี่ยวกับข้อมูลดังกล่าว ' +
                        'จะได้รับการดำเนินการให้เป็นไปตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล หรือกฎหมายอื่น นโยบายส่วนบุคคลฉบับนี้ ' +
                        'และนโยบายอื่น ๆ ของบริษัทฯ อย่างไรก็ตาม การยกเลิกดังกล่าวจะไม่ถือว่าเป็นการเพิกถอนการอนุญาตที่ได้ให้บริษัทฯ ' +
                        'ใช้และเปิดเผยข้อมูลดังกล่าวเว้นแต่จะได้ระบุไว้เป็นอย่างอื่นเป็นลายลักษณ์อักษร'
                    ]
                },
                {
                    topics: [
                        '8.2. บริษัทฯ จะไม่รับผิดในความเสียหายใด ๆ ที่เกิดขึ้นแก่ผู้ใช้บริการ และเกี่ยวเนื่องกับนโยบายข้อมูลส่วนบุคคลฉบับนี้ ' +
                        'หรือนิติสัมพันธ์อื่นใดระหว่างบริษัทฯ และผู้ใช้บริการ เว้นแต่ความเสียหายดังกล่าว เกิดจากการกระทำโดยจงใจ ' +
                        'หรือประมาทเลินเล่ออย่างร้ายแรง ของบริษัทฯ'
                    ]
                }
            ]
        },
        {
            header: '9. การเปลี่ยนแปลงนโยบายข้อมูลส่วนบุคคล',
            sections: [
                {
                    topics: [
                        '9.1. บริษัทฯ อาจปรับปรุงนโยบายข้อมูลส่วนบุคคลนี้เป็นครั้งคราว เพื่อให้สอดคล้องกับการให้บริการ การประกอบธุรกิจ ' +
                        'การดำเนินงานของบริษัท รวมทั้งข้อเสนอแนะและความคิดเห็นจากผู้ใช้บริการ โดยบริษัทอาจประกาศแจ้ง ' +
                        'การเปลี่ยนแปลงนโยบายข้อมูลส่วนบุคคลให้ผู้ใช้บริการทราบก่อนดำเนินการเปลี่ยนแปลง ' +
                        'หรืออาจส่งประกาศแจ้งเตือนการเปลี่ยนแปลงดังกล่าวให้ผู้ใช้บริการทราบโดยตรง'
                    ]
                }
            ]
        },
        {
            infos: [
                'นโยบายข้อมูลส่วนบุคคลฉบับนี้ จัดทำขึ้นเมื่อวันที่ 1 ธ.ค. 2564 (v.1)'
            ]
        }
    ])
}
